// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentMentorMeetingSchedule_outerContainer__eKUZj{
    width: 100%;
    min-height: 100vh;
    background-color: rgb(0, 0, 0 ,.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 600000;
    display: flex;
    align-items: center;
    place-content: center;
}
.PaymentMentorMeetingSchedule_innerContainer__v5\\+86{
width: 95%;
height: 90vh;
background-color: white;
border-radius: 20px;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding: 1rem;
}
.PaymentMentorMeetingSchedule_PaymentSessionIdContainer__p2way{
    display: flex;
    flex-direction: column;
    align-items: center;
    place-content: center;
}
.PaymentMentorMeetingSchedule_container_SubHeading__EIfPQ{
    font-weight: 400;
}
.PaymentMentorMeetingSchedule_chooseComponentsText__iK8RV{
    font-weight: 400;
    margin-top: 1rem;
    margin-bottom: 1.5rem;
}
.PaymentMentorMeetingSchedule_componentsContainer__ih8LL{
    display: flex;
    flex-wrap: wrap;
}
.PaymentMentorMeetingSchedule_individualComponent__Aha8c{
    display: flex;
    align-items: center;
    margin-right: 1rem;
    margin-bottom: 1rem;
}
.PaymentMentorMeetingSchedule_inputLabel__XTBd2{
    margin-left: .25rem;
}
.PaymentMentorMeetingSchedule_makePaymentContainer__JUNQM{
    width: 80%;
    height: 80%;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    position: relative;
}
.PaymentMentorMeetingSchedule_buttonContainer__lR5Vj {
    display: flex;
    justify-content: center; /* Center the buttons */
    margin-top: 1rem; /* Space above the buttons */
}

.PaymentMentorMeetingSchedule_buttonContainer__lR5Vj button {
    margin: 0 0.80rem; /* Minimal space between buttons */
}
.PaymentMentorMeetingSchedule_cross__dK5BE {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 1.5rem;
    cursor: pointer;
}
.PaymentMentorMeetingSchedule_cross__dK5BE > img {
    width: 2rem;
    height: 2rem;
    cursor: pointer;
}
.PaymentMentorMeetingSchedule_makePaymentContainerHeading__ibbU3{
    text-align: center;
    margin-bottom: 1rem;
    font-size: 2rem;
}
.PaymentMentorMeetingSchedule_makePaymentContainerSubText__\\+LGQL{
    font-size: 1.1rem;
    margin-bottom: 1rem;
    /* text-transform: capitalize; */
    width: 40%;
    margin: auto;
    margin-bottom: 1.5rem;
}
.PaymentMentorMeetingSchedule_makePaymentContainerAmount__mc\\+oC{
    font-weight: bold;
}
.PaymentMentorMeetingSchedule_makePaymentContainerPayButton__VaAKB{
    border-radius: 6px;
    /* background-color: rgb(105, 51, 211); */
    background-color: #2A72DE;
    color: rgb(255, 255, 255);
    border: none;
    font-size: 14px;
    padding: 11px 16px;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    cursor: pointer;
    width: 200px;
    margin: auto;
}


@media(max-width:1200px){
    .PaymentMentorMeetingSchedule_makePaymentContainerSubText__\\+LGQL{
        width: 90%;
        
    }
}

.PaymentMentorMeetingSchedule_makePaymentContainerCloseButton__GmbL\\+ {
    border-radius: 6px;
    /* background-color: rgb(105, 51, 211); */
    background-color: #2A72DE;
    color: rgb(255, 255, 255);
    border: none;
    font-size: 14px;
    padding: 11px 16px;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    cursor: pointer;
    width: 200px;
    margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/payment/PaymentMentorMeetingSchedule.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,MAAM;IACN,OAAO;IACP,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;AACA,UAAU;AACV,YAAY;AACZ,uBAAuB;AACvB,mBAAmB;AACnB,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,sBAAsB;AACtB,aAAa;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB,EAAE,uBAAuB;IAChD,gBAAgB,EAAE,4BAA4B;AAClD;;AAEA;IACI,iBAAiB,EAAE,kCAAkC;AACzD;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,UAAU;IACV,YAAY;IACZ,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI;QACI,UAAU;;IAEd;AACJ;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".outerContainer{\n    width: 100%;\n    min-height: 100vh;\n    background-color: rgb(0, 0, 0 ,.4);\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 600000;\n    display: flex;\n    align-items: center;\n    place-content: center;\n}\n.innerContainer{\nwidth: 95%;\nheight: 90vh;\nbackground-color: white;\nborder-radius: 20px;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nflex-direction: column;\npadding: 1rem;\n}\n.PaymentSessionIdContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    place-content: center;\n}\n.container_SubHeading{\n    font-weight: 400;\n}\n.chooseComponentsText{\n    font-weight: 400;\n    margin-top: 1rem;\n    margin-bottom: 1.5rem;\n}\n.componentsContainer{\n    display: flex;\n    flex-wrap: wrap;\n}\n.individualComponent{\n    display: flex;\n    align-items: center;\n    margin-right: 1rem;\n    margin-bottom: 1rem;\n}\n.inputLabel{\n    margin-left: .25rem;\n}\n.makePaymentContainer{\n    width: 80%;\n    height: 80%;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    position: relative;\n}\n.buttonContainer {\n    display: flex;\n    justify-content: center; /* Center the buttons */\n    margin-top: 1rem; /* Space above the buttons */\n}\n\n.buttonContainer button {\n    margin: 0 0.80rem; /* Minimal space between buttons */\n}\n.cross {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    font-size: 1.5rem;\n    cursor: pointer;\n}\n.cross > img {\n    width: 2rem;\n    height: 2rem;\n    cursor: pointer;\n}\n.makePaymentContainerHeading{\n    text-align: center;\n    margin-bottom: 1rem;\n    font-size: 2rem;\n}\n.makePaymentContainerSubText{\n    font-size: 1.1rem;\n    margin-bottom: 1rem;\n    /* text-transform: capitalize; */\n    width: 40%;\n    margin: auto;\n    margin-bottom: 1.5rem;\n}\n.makePaymentContainerAmount{\n    font-weight: bold;\n}\n.makePaymentContainerPayButton{\n    border-radius: 6px;\n    /* background-color: rgb(105, 51, 211); */\n    background-color: #2A72DE;\n    color: rgb(255, 255, 255);\n    border: none;\n    font-size: 14px;\n    padding: 11px 16px;\n    margin-bottom: 1.5rem;\n    margin-top: 1.5rem;\n    cursor: pointer;\n    width: 200px;\n    margin: auto;\n}\n\n\n@media(max-width:1200px){\n    .makePaymentContainerSubText{\n        width: 90%;\n        \n    }\n}\n\n.makePaymentContainerCloseButton {\n    border-radius: 6px;\n    /* background-color: rgb(105, 51, 211); */\n    background-color: #2A72DE;\n    color: rgb(255, 255, 255);\n    border: none;\n    font-size: 14px;\n    padding: 11px 16px;\n    margin-bottom: 1.5rem;\n    margin-top: 1.5rem;\n    cursor: pointer;\n    width: 200px;\n    margin: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `PaymentMentorMeetingSchedule_outerContainer__eKUZj`,
	"innerContainer": `PaymentMentorMeetingSchedule_innerContainer__v5+86`,
	"PaymentSessionIdContainer": `PaymentMentorMeetingSchedule_PaymentSessionIdContainer__p2way`,
	"container_SubHeading": `PaymentMentorMeetingSchedule_container_SubHeading__EIfPQ`,
	"chooseComponentsText": `PaymentMentorMeetingSchedule_chooseComponentsText__iK8RV`,
	"componentsContainer": `PaymentMentorMeetingSchedule_componentsContainer__ih8LL`,
	"individualComponent": `PaymentMentorMeetingSchedule_individualComponent__Aha8c`,
	"inputLabel": `PaymentMentorMeetingSchedule_inputLabel__XTBd2`,
	"makePaymentContainer": `PaymentMentorMeetingSchedule_makePaymentContainer__JUNQM`,
	"buttonContainer": `PaymentMentorMeetingSchedule_buttonContainer__lR5Vj`,
	"cross": `PaymentMentorMeetingSchedule_cross__dK5BE`,
	"makePaymentContainerHeading": `PaymentMentorMeetingSchedule_makePaymentContainerHeading__ibbU3`,
	"makePaymentContainerSubText": `PaymentMentorMeetingSchedule_makePaymentContainerSubText__+LGQL`,
	"makePaymentContainerAmount": `PaymentMentorMeetingSchedule_makePaymentContainerAmount__mc+oC`,
	"makePaymentContainerPayButton": `PaymentMentorMeetingSchedule_makePaymentContainerPayButton__VaAKB`,
	"makePaymentContainerCloseButton": `PaymentMentorMeetingSchedule_makePaymentContainerCloseButton__GmbL+`
};
export default ___CSS_LOADER_EXPORT___;
